// extracted by mini-css-extract-plugin
export default {"title":"TitleWithIndicator_title__eMAsU","subtitle":"TitleWithIndicator_subtitle__UVaXW","userName":"TitleWithIndicator_userName__q0t1P"};